// extracted by mini-css-extract-plugin
export default {"infoText":"index_infoText_gE9Xd"};